import { Controller } from 'stimulus'

export default class extends Controller {

  handleClick() {
    const formElement = this.element.closest('.compare-form')
    formElement.submit()
  }
}